import {
    FETCH_CURRENT_ACCOUNT,
    FETCH_CURRENT_ACCOUNT_FAILURE,
    FETCH_CURRENT_ACCOUNT_SUCCESS,
    UPDATE_CURRENT_ACCOUNT_SUCCESS,
    SORT_ASC,
} from 'store/actions/types';
import reducerHelper from 'helpers/reducers';

const initialState = {
    data: {},
    field: 'name',
    filter: {},
    filterCategory: reducerHelper.FILTER_BASIC,
    ids: [],
    loading: false,
    offset: 0,
    order: SORT_ASC,
    page: 1,
    size: 12,
    total: 0,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case FETCH_CURRENT_ACCOUNT:
            return Object.assign({}, state, {
                loading: true,
            });

        case FETCH_CURRENT_ACCOUNT_FAILURE:
            return Object.assign({}, state, {
                data: {},
                ids: [],
                loading: false,
                offset: 0,
                size: 0,
                total: 0,
            });

        case FETCH_CURRENT_ACCOUNT_SUCCESS:
            return Object.assign({}, state, {
                data: Object.assign({}, state.data, action.payload),
                ids: [
                    ...state.ids,
                    ...action.payload.id,
                ],
                loading: false,
            });

        case UPDATE_CURRENT_ACCOUNT_SUCCESS:
            return Object.assign({}, state, {
                data: Object.assign({}, state.data, action.payload),
                loading: false,
            });

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/store/reducers/currentAccountsReducer.js